import React, { useState } from "react";
import classes from "./Drawer.module.css";
import { useNavigate } from "react-router-dom";

const Drawer = ({ drawer, setDrawer }) => {
    const navigate = useNavigate();

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
        setDrawer(false);
    };

    return (
        <div
            className={`${classes.drawer} ${drawer && classes.show}`}
            onClick={() => setDrawer(false)}
        >
          <div
  className={classes.drawer_container}
  onClick={(e) => e.stopPropagation()}
>
  <div className={classes.menu_items}>
    <button className={classes.menu_item} onClick={() => scrollToSection('home')}>
      Home
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('trending')}>
      Trending
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('action')}>
      Action
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('adventure')}>
      Adventure
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('arcade')}>
      Arcade
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('general')}>
      General
    </button>
    <div className={classes.divider}></div>

    <button className={classes.menu_item} onClick={() => scrollToSection('puzzle')}>
      Puzzle
    </button>
  </div>
</div>

        </div>
    );
};

export default Drawer;